import React, { useEffect, useState } from "react";
import {
  DeleteAPICall,
  postAPICall,
  putAPICall,
  s3url,
  showErrorToast,
  showSuccessToast,
  showToast,
} from "../Api/Api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import "./Style.css";
import { MdDelete } from "react-icons/md";
import { FaVideo } from "react-icons/fa6";
import { MdDragIndicator } from "react-icons/md";
import DropArea from "./DropArea";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { useLoader } from "../GlobalComponents/Loader";

export default function PlaylistScheduleList(props) {
  const [PlaylistSchList, setPlaylistScheduleList] = useState([]);
  const [TotalDuration, setTotalDuration] = useState("00:00:00");
  const [RowCount, setRowCount] = useState(0);
  const [TotalSize, setTotalSize] = useState(0);
  const [ReorderSchId, setReorderSchId] = useState(0);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [selectedChennal, setDeletedvalue] = useState(null);
  const [location, SetVideoPath] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [selectedVideoSrc, setSelectedVideoSrc] = useState("");
  const [MediaLocation, setMediaLocation] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedRowValue, setSelectedRowValue] = useState(true);

  const defaultSchId = localStorage.getItem("SchId");
  const scheduleheaderid =
    props?.schnewid.toString() || localStorage.getItem("SchHdrId");
  useEffect(() => {
    let x =
      (props?.schnewid !== "" && props.schnewid !== null) ||
      localStorage.getItem("SchId") ||
      localStorage.getItem("SchHdrId")
        ? fetchScheduleList()
        : "";
  }, [props, TotalDuration]);

  const fetchScheduleList = async () => {
    // showLoader()
    const requestBody = {
      scheduleHeaderID: scheduleheaderid || localStorage.getItem("SchId"),
    };
    const response = await postAPICall(
      "api/PlayLists/GetScheduleList",
      requestBody
    );
    if (response?.status === 200) {
      UpdateplaylistdtlDuration();
      // hideLoader()
      setLoading(false);
      setPlaylistScheduleList(response?.data);
      setRowCount(response?.data?.length);
    } else {
      // hideLoader()
      setPlaylistScheduleList([]);
    }

    // Calculate total duration
    let sum = response.data.reduce((acc, item) => {
      const [hours, minutes, seconds] = item.MediaDuration.split(":");
      acc +=
        parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
      return acc;
    }, 0);
    const hours = Math.floor(sum / 3600);
    const minutes = Math.floor((sum % 3600) / 60);
    const seconds = sum % 60;
    const TotalDurationtime = `${formatNumber(hours)}:${formatNumber(
      minutes
    )}:${formatNumber(seconds)}`;

    setTotalDuration(TotalDurationtime);
    //UpdateplaylistdtlDuration();
    const totalSizeCalculation = response.data.reduce((acc, item) => {
      return acc + (item.MediaSizeMB || 0); // Ensure to handle missing or undefined mediaSizeMB
    }, 0);

    setTotalSize(totalSizeCalculation);
    // hideLoader()
  };

  const formatNumber = (number) => {
    return number < 10 ? `0${number}` : `${number}`;
  };
  //Data Grid value Reorder put PAI Call
  const handleReorderDrop = async (event) => {
    if (ReorderSchId) {
      const { originalEvent, value } = event;
      const oldOrderIndex = event.dragIndex + 1;
      const newOrderIndex = event.dropIndex + 1;
      // Now you have the dropped row index
      const requestBody = {
        scheduleHeaderID: ReorderSchId,
        OldOrderNo: oldOrderIndex,
        OrderNo: newOrderIndex,
      };
      const response = await putAPICall(
        "api/PlayLists/PutScheduleList",
        requestBody
      );
      fetchScheduleList();
    }
  };
  const onDragStart = (e, rowData) => {
    setReorderSchId(rowData.SchHdrID);
  };
  // const onDrop = async (e, droppedIndex) => {

  //   if (props.SchdrID != "" || defaultSchId) {
  //     const validationSetdragdata = localStorage.getItem("rowData");
  //     if (validationSetdragdata) {
  //       if (props.DragData.length != 0) {
  //         const MediaData = PlaylistSchList.find((product) => product.SchHdrID);
  //         let OrderNo = 0;

  //         if (filteredData.length != 0) {
  //           if (droppedIndex.rowIndex === 0) OrderNo = 1;
  //           else OrderNo = droppedIndex.rowIndex + 1;
  //         }

  //         const requestBody = {
  //           scheduleHeaderID: defaultSchId ?? props.SchdrID,
  //           OrderNo: OrderNo, //DragOrdernumber,
  //           MediaID: props.DragData.MediaID,
  //           MediaName: props.DragData.MediaName,
  //           MediaType: props.DragData.MediaType,
  //           MediaDuration: props.DragData.MediaDuration,
  //         };
  //         const response = await postAPICall(
  //           "api/PlayLists/PostScheduleList",
  //           requestBody
  //         );
  //         fetchScheduleList();
  //         showSuccessToast("Addedd Succesfully");

  //         localStorage.removeItem("rowData");
  //       }
  //     }
  //   } else {
  //     showErrorToast("Please Select Schedule Header !!");
  //   }
  // };
  const onDrop = async (e, droppedIndex, rowIndexValue) => {
    e.preventDefault();
    e.stopPropagation(); // ✅ Prevent duplicate calls

    if (!props.SchdrID && !defaultSchId) {
      showErrorToast("Please Select Schedule Header !!");
      return;
    }

    const dragData = localStorage.getItem("rowData");
    if (!dragData) return;

    // Parse drag data
    const draggedItem = props.DragData;

    if (
      !draggedItem ||
      typeof draggedItem !== "object" ||
      Object.keys(draggedItem).length === 0
    ) {
      showErrorToast("Invalid Drag Data!");
      return;
    }

    // ✅ Determine correct OrderNo (avoid duplicate drops)
    let OrderNo =
      droppedIndex?.rowIndex !== undefined
        ? droppedIndex.rowIndex + 2
        : rowIndexValue?.rowIndex !== undefined
        ? rowIndexValue.rowIndex + 1
        : 1;

    const requestBody = {
      scheduleHeaderID: defaultSchId ?? props.SchdrID,
      OrderNo,
      MediaID: draggedItem.MediaID,
      MediaName: draggedItem.MediaName,
      MediaType: draggedItem.MediaType,
      MediaDuration: draggedItem.MediaDuration,
    };

    try {
      const response = await postAPICall(
        "api/PlayLists/PostScheduleList",
        requestBody
      );

      if (response) {
        await fetchScheduleList(); // Refresh data
        showSuccessToast("Added Successfully");
        localStorage.removeItem("rowData");
      } else {
        showErrorToast("Failed to add item");
      }
    } catch (error) {
      console.error("Error in onDrop:", error);
      showErrorToast("An error occurred while adding.");
    }
  };

  //Show Edit Confirmation popup
  const handleDelete = () => {
    setDeleteConfirmation(true);
  };
  //Set All row Edit Icon
  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          id="UserTOAccountDeleteIcon"
          icon={<MdDelete />}
          className="p-button-rounded p-button-primary"
          title="Delete"
          onClick={() => {
            setDeletedvalue(rowData);
            handleDelete();
          }}
        />
      </div>
    );
  };
  //Schedule List Delete Event APICall
  const handleConfirmDelete = async () => {
    const requestBodydelete = {
      scheduleHeaderID: selectedChennal.ScheduleHdrID,
      ScheduleDetailID: selectedChennal.SchDtlID,
      OrderNo: selectedChennal.OrderNo,
    };
    const response = await DeleteAPICall(
      "api/PlayLists/DeleteScheduleList",
      requestBodydelete
    );
    fetchScheduleList();
    setDeleteConfirmation(false);
    showSuccessToast("Deleted...");
    //UpdateplaylistdtlDuration();
  };
  // Video Privew
  const handleCloseDialog = () => {
    setShowDialog(false);
  };
  //Play Event
  // const handlePreviewClick = (rowData) => {
  //   setSelectedVideoSrc(rowData.MediaLocation);
  //   if (rowData !== undefined) {
  //     const Videolocation = s3url + rowData.MediaLocation;
  //     SetVideoPath(Videolocation);
  //     setShowDialog(true);
  //     setTimeout(() => {
  //       const videoElement = document.getElementById("videoplay");
  //       if (videoElement) {
  //         videoElement.play();
  //       }
  //     }, 500);
  //   }
  // };
  const handlePreviewClick = (rowData) => {
    if (rowData !== undefined) {
      // Set the video source URL
      setSelectedVideoSrc(rowData.MediaLocation);

      // Construct the full video URL
      const videoLocation = s3url + rowData.MediaLocation;
      SetVideoPath(videoLocation);

      // Show the dialog for video preview
      setShowDialog(true);

      // Ensure the video element is properly loaded and ready
      const videoElement = document.getElementById("videoplay");

      if (videoElement) {
        videoElement.src = videoLocation; // Set video source
        videoElement.load(); // Ensure the video is reloaded before playing

        // Play the video after it has loaded
        videoElement.oncanplay = () => {
          videoElement.play().catch((error) => {
            console.error("Error playing video:", error);
          });
        };
      }
    }
  };
  //Priview Icon set
  const previewIconTemplate = (rowData) => {
    return (
      <Button
        icon={<FaVideo />}
        id="playicon"
        className="p-button p-button-text"
        onClick={() => handlePreviewClick(rowData)}
      >
        {/* <span
          id="PlayIconImage"
          role="img"
          aria-label="Play video"
          title="Play"
        >
          ▶️
        </span> */}
      </Button>
    );
  };
  //Row Click to Get And Store Vlue
  const HandleRowSelect = (e) => {
    setSelectedRowValue(e?.value);
    setMediaLocation(e?.value?.MediaLocation);
  };
  //Enter Key Press to play Video and Escape Key Click to Exit
  // const HandleKeyDown = (e) => {
  //   if (e.code === "Enter") {
  //     const Videolocation = s3url + MediaLocation;
  //     SetVideoPath(Videolocation);
  //     setShowDialog(true);
  //     setTimeout(() => {
  //       const videoElement = document.getElementById("videoplay");
  //       if (videoElement) {
  //         videoElement.play();
  //       }
  //     }, 500); // Adjust delay as needed
  //   } else if (e.code === "Escape") {
  //     setShowDialog(false);
  //   }
  // };
  const HandleKeyDown = (e) => {
    debugger;
    if (e.code === "Enter") {
      const Videolocation = s3url + MediaLocation;
      SetVideoPath(Videolocation);
      setShowDialog(true);

      setTimeout(() => {
        const videoElement = document.getElementById("videoplay");

        // Ensure the video element is still present and ready
        if (videoElement && videoElement.readyState >= 3) {
          videoElement.play().catch((error) => {
            console.error("Error playing video: ", error);
          });
        } else {
          console.error("Video element is not ready to play.");
        }
      }, 500); // Adjust delay as needed
    } else if (e.code === "Escape") {
      setShowDialog(false);
    }
  };

  //Duration Api call event
  const UpdateplaylistdtlDuration = () => {
    PlaylistHeaderDurationUpdateAPICALL();
  };
  //Duration Update Api call
  const PlaylistHeaderDurationUpdateAPICALL = async () => {
    // let scheduleHeaderID = scheduleheaderid;
    //let scheduleHeaderID = localStorage.getItem("SchId");
    if (scheduleheaderid && TotalDuration) {
      const requestBody = {
        scheduleHdrId: scheduleheaderid,
        Duration: TotalDuration,
        MediaSize: TotalSize,
      };
      const response = await putAPICall(
        "api/PlayLists/PutScheduleHeaderDuration",
        requestBody
      );
      if (props.DurationUpdateCheck == "DurationUpdateCheck") {
        props.DurationupdateEvent(TotalDuration);
      }
    }
  };
  const filteredData = PlaylistSchList?.filter(
    (PlaylistSchList) =>
      PlaylistSchList.MediaName.toLowerCase().includes(
        searchQuery.toLowerCase()
      ) ||
      PlaylistSchList.MediaDuration.toLowerCase().includes(
        searchQuery.toLowerCase()
      )
  );
  const PlaylistScheduleListDeleteConfirmation = (
    <div>
      <Button
        style={{ borderRadius: "5px", padding: "15px" }}
        label="Yes"
        icon="pi pi-check"
        onClick={handleConfirmDelete}
        autoFocus
      />
      <Button
        style={{
          borderRadius: "5px",
          padding: "15px",
          backgroundColor: "lightslategray",
          color: "white",
        }}
        label="No"
        icon="pi pi-times"
        onClick={() => setDeleteConfirmation(false)}
        className="p-button-text"
      />
    </div>
  );
  const onDropOutside = (e) => {
    e.preventDefault();
    e.stopPropagation(); // ✅ Prevent event bubbling

    // Find the column name from the event target
    const columnName = e.target.closest("td")?.getAttribute("data-field");

    // Prevent drop on "MediaName" or "MediaDuration"
    if (columnName === "MediaName" || columnName === "MediaDuration") {
      return;
    }

    // Get the last index of the table
    const lastIndex = filteredData.length;

    // Call onDrop with last index
    onDrop(e, null, { rowIndex: lastIndex });
  };

  // const onDropOutside = (e) => {
  //   // e.preventDefault();

  //   const lastIndex = filteredData.length > 0 ? filteredData.length : 0;

  //   onDrop(e, { rowIndex: lastIndex });
  // };

  return (
    <div style={{ height: "87vh" }}>
      <div id="PlayListScheduleListHeaderCard">
        {/* <b id="SchHdrname-text">{props.SchHdrname ?props.SchHdrname:localStorage.getItem("ScheduleHdrName")}</b>  */}
        <b
          id="SchHdrname-text"
          //className="text-ellipsis column-border"
          title={
            props.SchHdrname
              ? props.SchHdrname
              : localStorage.getItem("SchName")
          }
        >
          {props.SchHdrname
            ? props.SchHdrname
            : localStorage.getItem("SchName")}
        </b>
        <b hidden>{props.schnewid}</b>
        <InputText
          id="PlaylistSchedulelistSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          title="Search"
          // className="p-button-primary"
        />
      </div>

      {loading && props.schnewid ? (
        <ProgressSpinner
          style={{ width: "50px", height: "30px", marginTop: "auto" }}
          strokeWidth="3"
        />
      ) : (
        <>
          <div
            onDragOver={(e) => e.preventDefault()} // Allow drop everywhere
            onDrop={onDropOutside} // Handle dropping outside
          >
            <DataTable
              className={
                props?.VisibleName ? "PlaylistScheduleList-Datatable" : ""
              }
              value={filteredData}
              scrollable
              scrollHeight={props?.VisibleName ? "350px" : "490px"}
              reorderableColumns
              onSelectionChange={HandleRowSelect}
              reorderableRows
              onRowReorder={handleReorderDrop}
              selectionMode="single"
              onKeyDown={HandleKeyDown}
              rowClassName={(rowData) =>
                selectedRowValue &&
                selectedRowValue.SchDtlID === rowData.SchDtlID
                  ? "selected-row"
                  : ""
              }
            >
              <Column
                style={{ width: "2px" }}
                hidden={props.HideDragIcon}
                body={(rowData) => (
                  <div draggable onDragStart={(e) => onDragStart(e, rowData)}>
                    <Button
                      id="PlayListSchListDragIcon"
                      icon={<MdDragIndicator />}
                      title="Drag"
                    />
                  </div>
                )}
              />
              <Column
                field="MediaName"
                header="Media Name"
                sortable
                className="text-ellipsis"
                body={(rowData, index) => (
                  <div
                    className="text-ellipsis"
                    style={{
                      width: "auto", // Set fixed width
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap", // Prevent text wrap
                    }}
                    draggable
                    onDragStart={(e) => onDragStart(e, rowData)}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDrop(e, index);
                    }}
                  >
                    <span title={rowData.MediaName}>{rowData.MediaName}</span>
                  </div>
                )}
              />
              <Column
                field="MediaDuration"
                header="Duration"
                align="left"
                body={(rowData, index) => (
                  <div
                    draggable
                    onDragStart={(e) => onDragStart(e, rowData)}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation(); // ✅ Prevent duplicate drop
                      onDrop(e, index);
                    }}
                  >
                    <span title={rowData.MediaDuration}>
                      {rowData.MediaDuration}
                    </span>
                  </div>
                )}
              />
              <Column header="Size(MB)" field="MediaSizeMB" />
              <Column header="Actions" body={actionTemplate} align="left" />
              <Column
                hidden={props.hidePlayicon === "hidePlayicon"}
                header="Preview"
                width={100}
                allowFiltering={false}
                allowSorting={false}
                body={previewIconTemplate}
              />
              <Column field="OrderNo" header="OrderNo" hidden />
            </DataTable>
          </div>

          {/* {PlaylistSchList.length === 0 ? (
            <DropArea onDrop={onDrop}>
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  border: "1px dashed gray",
                }}
              >
                Drag items here to populate the grid
              </div>
            </DropArea>
          ) : (
            <DataTable
              value={filteredData}
              scrollable
              scrollHeight="490px"
              reorderableColumns
              onSelectionChange={HandleRowSelect}
              reorderableRows={true} // Enable row reordering
              onRowReorder={handleReorderDrop} // Event handler for row reordering
              // onDragLeave={onDragLeave}
              selectionMode="single"
              onKeyDown={HandleKeyDown}
              //onDropCapture={DropCapture}
              rowClassName={(rowData) =>
                selectedRowValue &&
                selectedRowValue.SchDtlID === rowData.SchDtlID
                  ? "selected-row"
                  : ""
              }
            >
              <Column
                style={{ width: "2px" }}
                hidden={props.HideDragIcon ? true : false}
                body={(rowData, index) => (
                  <div
                    draggable
                    onDragStart={(e) => onDragStart(e, rowData)}
                    onDrop={(e) => onDrop(e, index)}
                  >
                    <Button
                      id="PlayListSchListDragIcon"
                      icon={<MdDragIndicator />}
                      title="Drag"
                    ></Button>
                  </div>
                )}
              ></Column>

              <Column
                field="MediaName"
                header="MediaName"
                sortable
                style={{ border: "1px slid black" }}
                className="text-ellipsis"
                // body={(rowData) => {
                //   return <span title={rowData.MediaName}>{rowData.MediaName}</span>;
                // }}
                body={(rowData, index) => (
                  <div
                    onDragStart={(e) => onDragStart(e, rowData)}
                    onDrop={(e) => onDrop(e, index)}
                  >
                    <span title={rowData.MediaName}>{rowData.MediaName}</span>
                  </div>
                )}
              />
              <Column
                field="MediaDuration"
                header="Duration"
                align={"left"}
                body={(rowData, index) => (
                  <div
                    onDragStart={(e) => onDragStart(e, rowData)}
                    onDrop={(e) => onDrop(e, index)}
                  >
                    <span title={rowData.MediaDuration}>
                      {rowData.MediaDuration}
                    </span>
                  </div>
                )}
              />
              <Column header="Size(MB)" field="MediaSizeMB" />
              <Column header="Actions" body={actionTemplate} align={"left"} />

              <Column
                hidden={props.hidePlayicon == "hidePlayicon" ? true : false}
                header="Preview"
                width={100}
                allowFiltering={false}
                allowSorting={false}
                body={previewIconTemplate}
              />
              <Column field="OrderNo" header="OrderNo" hidden />
            </DataTable>
          )} */}
        </>
      )}
      {/* <hr /> */}
      <div
        className={props?.VisibleName ? "PlaylistScheduleList-Datatable" : ""}
        style={{ display: "flex", gap: "60px" }}
      >
        <b>Rows count: {RowCount}</b>
        <b>Total Size(MB): {TotalSize}</b>
        <b> Duration: {TotalDuration}</b>
      </div>

      <GlobalPopup
        title={"Confirmation"}
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={PlaylistScheduleListDeleteConfirmation}
        content={
          <div className="confirmation-content">
            <br />
            <h6> Are you sure you want to delete this item?</h6>
          </div>
        }
      />
      <GlobalPopup
        title={props.SchHdrname ? props.SchHdrname : "Preview"}
        visible={showDialog}
        onHide={handleCloseDialog}
        footerButtons={
          <div>
            <video id="videoplay" controls tabIndex="0">
              <source src={location} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        }
        Popupwidth={800}
        Popupheight={500}
      />
    </div>
  );
}
